<template>
  <section class="p-2">
    <v-card class="pt-4">
      <p class="ms-2 mb-1 font-weight-bold">Country Setup</p>
      <v-divider class="p-0 m-0"></v-divider>
      <v-card-title>
        <v-form ref="form" v-model="valid">
          <v-row class="mt-2">
            <v-col cols="12" lg="6" xs="12">
              <v-combobox
                clearable
                multiple
                v-model="selectedcoutry"
                class="rounded mx-2"
                :items="countrylist"
                :rules="countryRules"
                outlined
                dense
                placeholder="Country"
              >
              </v-combobox>
            </v-col>

            <v-col cols="12" lg="2" xs="12">
              <v-btn
                depressed
                color="primary"
                @click="selectCountry"
                class="mx-2 mt-1 primary text-capitalize"
                small
              >
                Get Results</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col></v-col>
          <v-col cols="12" md="6"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field></v-col
        ></v-row>
      </v-card-title>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :search="search"
        class="mt-7"
        dense
        :items="country"
        no-data-text="Please select the criteria to view records."
      >
        <template v-slot:item.actions="{ item }">
          <v-icon color="grey" class="mr-2" @click="nextpage(item)">
            mdi-chevron-right-circle
          </v-icon>
        </template>

        <template v-slot:item.is_active="{ item }">
          <v-switch
            @change="isactiveupdate(item)"
            v-model="item.is_active"
            height="0px"
            dense
            color="success"
          ></v-switch>
        </template>
      </v-data-table>
      <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    </v-card>
  </section>
</template>

<script>
import Loading from "vue-loading-overlay";
import alerts from "@/mixins/alerts";
import setupService from "@/services/SetupService/setupService";
export default {
  mixins: [alerts],
  name: "Country Setup",
  tempArray: [],
  data: () => {
    return {
      search: "",
      valid: true,
      countryRules: [(v) => v.length > 0 || "Select country"],

      headers: [
        { text: "Id", value: "id" },
        { text: "Country Name", value: "name" },
        { text: "Country Code", value: "iso_alpha3" },
        { text: "Currency Code", value: "currency_code" },
        { text: "Tele Code", value: "dial_code" },
        // { text: 'Action', value: 'actions', sortable: false, },
        { text: "Active", value: "is_active", sortable: false },
        { text: "Navigate", value: "actions", sortable: false },
      ],

      selectedcoutry: [],
      loader: false,
      countrylist: [],
      country: [],
      tempCountries: [],
    };
  },
  mounted() {
    this.getcountryList();
    console.log(this.$route.params);
  },

  components: {
    Loading,
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.data.status_code === 200) {
          this.countrylist = response.data.data.map((i) => i.name);
          // this.country = response.data
          this.tempCountries = response.data.data;
          if (this.$route.params.name) {
            this.selectedcoutry.push(this.$route.params.name);
            this.selectCountry();
          }
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getcountryList();
        // }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    selectCountry() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        this.country = [];
        this.tempCountries.forEach((data) => {
          this.selectedcoutry.forEach((country) => {
            if (data.name == country) {
              this.stoploader();
              this.country.push(data);
            }
          });
        });
        console.log(this.selectedcoutry, JSON.stringify(this.country));
      }
    },

    // allcountries() {
    //   this.country = this.tempCountries;
    // },

    nextpage(item) {
      this.$router.push({
        name: "Country Additional",
        query: { name: item.name, iso3: item.iso_alpha3, id: item.id },
      });
      console.log("item.iso_alpha3", item.iso_alpha3);
    },
    async isactiveupdate(isactive) {
      this.loader = true;
      try {
        const responseData = await setupService.updateCountrystatus(
          isactive.id,
          isactive.is_active
        );
        setTimeout(() => {
          this.loader = false;
        }, 200);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.loader = false;
          this.getcountryList();
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.isactiveupdate(isactive);
        // }
        else {
          setTimeout(() => {
            this.loader = false;
          }, 200);
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (error) {
        setTimeout(() => {
          this.loader = false;
        }, 200);
        this.showAlertError(error.data.message);
        console.error(error);
      }
    },
  },
};
</script>
